interface LayoutProps extends React.PropsWithChildren {}

export default function Layout(props: LayoutProps) {
  return props.children;
}
